import * as Yup from "yup";

/* Manage Fleet */

const price = RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
const registration_no = RegExp(/^\d+$/);

export const Validation = Yup.object().shape({
  name: Yup.string().required("name is required"),
  vehicle_model: Yup.string().required("vehicle model is required"),
  price: Yup.string()
    .matches(price, "Please enter a price")
    .required("price is required"),
  color: Yup.string().required("color is required"),
  registration_no: Yup.string()
    .matches(registration_no, "Please enter a number")
    .required("registration no is required"),
  fuel_type: Yup.string().required("fuel type is required"),
  license_plate: Yup.string().required("license plate is required"),
  status: Yup.string().required("status is required"),
});

/* Manage Staff */

// const mobileRegex = RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
// export const ValidationStaff = Yup.object().shape({
//   firstName: Yup.string().required("First Name is required"),
//   // middleName: Yup.string().required("Middle Name is required"),
//   lastName: Yup.string().required("Last Name is required"),
//   employee_id: Yup.string().required("Employee Id is required"),
//   mobile: Yup.string().required("Phone number is required"),
//   email: Yup.string()
//     .email("Email must be a valid email")

//     .required("Email is required"),
//   designation: Yup.string().required("Designation is required"),
//   experience: Yup.string().required("Experience is required"),
//   lic_no: Yup.number()
//     .min(255, "Please enter a valid license number")
//     .required("License number is requried"),
// });

//Add staff
const mobileRegex = RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
export const ValidationAddStaff = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  // middleName: Yup.string().required("Middle Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  employee_id: Yup.string().required("Employee Id is required"),
  // mobile: Yup.string().required("Phone number is required"),
  email: Yup.string()
    .email("Email must be a valid email")

    .required("Email is required"),
  designation: Yup.string().required("Designation is required"),
  experience: Yup.string().required("Experience is required"),
  lic_no: Yup.string()
    .min(5, "Please enter a valid license number")
    .required("License number is requried"),
});

/* Manage Customers */
const phoneRegex = RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
export const ValidationCustomer = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  // mobile: Yup.string().required("Phone Number is required"),
  email: Yup.string()
    .email("Email must be a valid email")
    .required("Email is required"),
  password: Yup.string().required("Password is required").min(8),
  // city: Yup.string().required("Address is required"),
});

/* Manage Service */

export const ValidationService = Yup.object().shape({
  name: Yup.string().required("Services name is required"),
  price: Yup.number()
    .required("Price is required")
    .typeError("Please enter a number"),
  tooltip: Yup.string().required("Tooltip is required"),
  detail: Yup.string().required("Detail is required"),
});
export const Order_Validation = Yup.object().shape({
  note: Yup.string().required("Message is required"),
});

/* Manage Membership */

export const ValidationAddMembership = Yup.object().shape({
  name: Yup.string().required("Services name is required"),
  order_Counts: Yup.string().required("Order counts is required"),
  // price: Yup.string()
  //   .required("Membership price is required")
  //   .typeError("Please enter a string"),
});

export const ValidationResetPassword = Yup.object().shape({
  password: Yup.string().required("Password is required"),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
});

/* Manage Stripe Key */

export const ValidationStripeKey = Yup.object().shape({
  key: Yup.string().required("Key is required"),
});

// Manage Vehicle
const singleEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const ValidationOrder = Yup.object().shape({
  date: Yup.string().required("Date is required"),
  name: Yup.string().required("Name is required"),
  business: Yup.string().optional(),
  email: Yup.string()
    .required("Email is required")
    .test(
      "valid-email-list",
      "Enter one or more valid emails, separated by commas",
      (value) =>
        !!value &&
        value.split(",").every((part) => singleEmailRegex.test(part.trim()))
    ),
  phone: Yup.string().required("Phone number is required"),
  // orderNo: Yup.string().required("Order number is required"),
  address: Yup.string().required("Address is required"),
  transationCharges: Yup.number()
    .required("Transaction charges are required")
    .typeError("Please enter a number"),
  tipAmount: Yup.number()
    .optional()
    .min(0, "Tip cannot be negative")
    .typeError("Please enter a number"),
  isPaid: Yup.boolean().required("Payment status is required"),
  // address: Yup.number()
  //   .required("Total amount is required")
  //   .typeError("Please enter a number"),
  paymentMethod: Yup.string().required("Payment method is required"),
  technician: Yup.string().required("Technician agent is required"),
});

export const ValidationVehicle = Yup.object().shape({
  name: Yup.string().required("Vehicle name is required"),
  vehicle_model: Yup.string().required("Vehicle model is required"),
  // year: Yup.number().required("Year is required"),
  year: Yup.date()
    .max(new Date().getFullYear())
    .required("Year is required")
    .typeError("Please enter valid year"),
  color: Yup.string().required("Color is required"),
  registration_no: Yup.string().required("Registration number is required"),
  price: Yup.number()
    .required("Price is required")
    .typeError("Please enter a number"),
  isBooked: Yup.string().required("Booking status is required"),
  status: Yup.string().required("Status is required"),
});

// add on
export const ValidationAddOnVehicle = Yup.object().shape({
  addName: Yup.string().required("Name of add on is required"),
  // childPrice: Yup.number()
  // .required("Child price is required")
  // .typeError("Please enter a number"),
  price: Yup.number()
    .required("Price is required")
    .typeError("Please enter a number"),
  // mobilePrice: Yup.number()
  //   .required("Mobile price is required")
  //   .typeError("Please enter a number"),
  // driverPrice: Yup.number()
  //   .required("Driver price is required")
  //   .typeError("Please enter a number"),
});

// Manage Fleet
export const ValidationFleet = Yup.object().shape({
  name: Yup.string().required("Vehicle name is required"),
  vehicle_model: Yup.string().required("Vehicle model is required"),
  // year: Yup.number().required("Year is required"),
  year: Yup.date()
    .max(new Date().getFullYear(), "Year field must be at earlier than 2023")
    .required("Year is required")
    .typeError("Please enter valid year"),
  color: Yup.string().required("Color is required"),
  registration_no: Yup.string().required("Registration number is required"),
  license_plate: Yup.string().required("License Plate is required"),
  fuel_type: Yup.string().required("Fuel Type is required"),
  status: Yup.string().required("Status is required"),
});

// edit customer pass
export const ValidationEditCustomerPass = Yup.object().shape({
  password: Yup.string().required("Password is required"),
  // confirmPassword: Yup.string().required("Confirm password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});
export const TransationCharges = Yup.object().shape({
  transaction: Yup.string().required("Transaction charge is required"),
});
export const Pricing = Yup.object().shape({
  surge: Yup.string().required("Surge price is required"),
  startTime: Yup.string().required("Start date is required"),
  endTime: Yup.string().required("End date is required"),
});
